module.exports = {
    alt: {
        video_cover: "Design Mirror 实时预览演示视频封面",
        feature_zoom: "在手机上缩放查看设计稿，自动适配屏幕",
        feature_multidoc: "多文档与多画布之间快速切换预览",
        feature_snapshot: "截屏快照与设计稿图像对比功能",
        feature_upload: "把手机相册中的图片上传回设计软件",
        wechat_qr: "Design Mirror 微信公众号二维码",
        qq_qr: "Design Mirror QQ 交流群二维码",
        ps_panel: "Photoshop 中的 Design Mirror 插件面板",
        ps_install: "Photoshop 插件安装步骤截图",
        sketch_panel: "Sketch 中的 Design Mirror 插件面板",
        sketch_install: "Sketch 插件安装步骤截图",
        xd_panel: "Adobe XD 中的 Design Mirror 插件面板",
        figma_install: "在 Figma 中安装并使用 Design Mirror 插件",
        jsdesign_preview: "即时设计中使用 Design Mirror 预览",
        mastergo_preview: "MasterGo 中使用 Design Mirror 预览",
        mobile_app: "Design Mirror 手机 App 预览界面",
        pricing: "Design Mirror 订阅方案对比",
    },
    navbar: {
        v4overview: "4.0 新版总览",
        home: "首页",
        v4: "V4 正式版",
        install: "安装",
        buy: "购买",
        mobile: "移动App下载",
        individual: "个人购买",
        team: "团队购买",
        help: "帮助",
        login: "登录",
        register: "注册",
        forgot_pass: "忘记密码",
        logout: "退出登录"
    },
    v4: {
        hero: {
            eyebrow: "Design Mirror V4 · 正式发布",
            title: "全新 V4 版本<br>现已<span class=\"text-primary\">正式发布</span>",
            description: "我们用全新架构重写了 Design Mirror —— 主攻大家反馈最多的「连不上」问题。现在就下载安装，体验新一代实时预览。",
            cta: "立即下载"
        },
        features: {
            title: "V4 新特性",
            description: "围绕「连接稳定性」做了彻底重构，并带来了全新原生 App 与更快的同步体验。",
            list: [
                {
                    title: "连接稳定性大幅提升",
                    description: "全新多层设备发现：局域网 mDNS → 云信令 → 二维码 → USB 自动回退。换网络、公司网络隔离、复杂环境也能稳定连上。"
                },
                {
                    title: "USB 连接（免 Wi-Fi）",
                    description: "没有可用 Wi-Fi 或网络受限时，用数据线连接电脑也能实时预览，连接更快更稳。"
                },
                {
                    title: "全新原生 App",
                    description: "iOS 与 Android 全部用原生（SwiftUI / Kotlin）重写，界面更流畅、更省电，连接体验焕然一新。"
                },
                {
                    title: "一个安装包，多个设计工具",
                    description: "桌面端一次安装，Photoshop / <b class=\"text-primary\">Illustrator</b> / Sketch / Adobe XD 插件全部就位；Figma / MasterGo / 即时设计 提供插件包，下载导入即用。"
                },
                {
                    title: "更快的实时同步",
                    description: "瓦片增量同步，只传输画面变化的部分，更新更快、更省流量，大长图也顺畅。"
                },
                {
                    title: "多设备同时预览",
                    description: "一台电脑可同时连接多部手机 / 平板，并排查看不同尺寸机型的适配效果。"
                }
            ]
        },
        download: {
            title: "下载 Design Mirror V4",
            description: "桌面端一个安装包搞定全部 —— 自动装好 Photoshop / Illustrator / Sketch / XD 插件与后台连接助手；手机端安装 App 即可开始预览。",
            desktop_hint: "版本 {version} · 安装后重启设计软件即可使用",
            items: [
                {
                    key: "windows",
                    icon: "uil-desktop",
                    title: "Windows 桌面端",
                    description: "支持 Windows 10 / 11，包含 Photoshop / Illustrator / Sketch / XD 插件与连接助手。",
                    button: "下载 .exe 安装包"
                },
                {
                    key: "mac",
                    icon: "uil-apple",
                    title: "macOS 桌面端",
                    description: "支持 Intel 与 Apple Silicon（M 系列）芯片，包含全部插件与连接助手。",
                    button: "下载 .pkg 安装包"
                },
                {
                    key: "android",
                    icon: "uil-android",
                    title: "Android App",
                    description: "通过蒲公英安装，请用手机浏览器打开下载（不要用微信扫码）。",
                    button: "去蒲公英下载"
                },
                {
                    key: "ios",
                    icon: "uil-apple",
                    title: "iOS App",
                    description: "已在 App Store 上架，需要 iOS 17.0 及以上系统，可直接搜索「Design Mirror」或点击下载。",
                    button: "App Store 下载"
                }
            ],
            plugins: {
                title: "Figma / MasterGo / 即时设计 插件包",
                description: "这三款工具的插件已上架各自的官方插件市场，直接搜索 Design Mirror 安装即可（需先安装上方桌面端）。下方的插件包仅作为插件市场访问不畅时的备用。",
                button: "下载插件包 .zip"
            }
        },
        install: {
            title: "安装与使用步骤",
            description: "四步搞定，从安装到手机上看到设计稿只要几分钟。",
            steps: [
                {
                    title: "安装桌面端",
                    description: "下载对应系统的安装包，双击运行，一路下一步即可。Photoshop / Illustrator / Sketch / XD 插件和后台连接助手会一次性自动装好。"
                },
                {
                    title: "手机安装 App",
                    description: "iPhone 直接在 App Store 搜索「Design Mirror」安装（需 iOS 17.0 及以上）；Android 手机用浏览器打开蒲公英页面下载安装（如提示，请允许安装）。"
                },
                {
                    title: "打开设计软件与插件面板",
                    description: "重启设计软件后打开插件：Photoshop / Illustrator 在 菜单 → 窗口 → 扩展（插件）→ Design Mirror；Sketch 在 菜单 → 插件 → Design Mirror；XD 在 菜单 → 插件 → Design Mirror。"
                },
                {
                    title: "自动连接，开始预览",
                    description: "手机和电脑连同一网络，打开 App 会自动发现你的电脑，点击即连；复杂网络下会自动切换云端通道，也可以扫码或插 USB 数据线连接。"
                }
            ],
            web_plugins: {
                title: "Figma / MasterGo / 即时设计：从插件市场安装",
                description: "从各自的官方插件市场安装插件即可，浏览器版和桌面客户端都支持：",
                items: [
                    "Figma：在 Figma 社区搜索 Design Mirror 安装，之后从 Plugins → Design Mirror 运行",
                    "MasterGo：在插件市场搜索 Design Mirror 安装，之后在插件列表中运行",
                    "即时设计：在插件市场搜索 Design Mirror 安装，之后在插件列表中运行"
                ],
                note: "插件通过后台运行的桌面助手和手机通信，所以电脑上需要装好 Design Mirror 桌面端；助手随开机自动运行，不需要开着窗口。"
            }
        },
        contact: {
            title: "遇到问题？直接找开发者",
            description: "使用中遇到问题或有建议，欢迎第一时间反馈给我。扫码添加微信，备注「V4」。",
            qrhint: "微信扫一扫 · 备注「V4」",
            fallback: "如二维码无法识别，可邮件联系：xiaoqiang@cutterman.cn"
        }
    },
    footer: {
        description: "Design Mirror是设计效率工具Cutterman旗下的另外一款产品，旨在服务广大设计师群体，为提高设计效率而生。",
        link: "相关链接",
        links: [
            {
                text: "Cutterman - 最好用的切图工具",
                link: "https://www.cutterman.cn"
            },
            {
                text: "打字鸭 - 免费在线打字网站",
                link: "https://www.daziya.com"
            },
            {
                text: "服务协议",
                link: "/terms"
            },
            {
                text: "隐私政策",
                link: "/privacy"
            },
        ]
    },
    index: {
        title: "实时预览您的设计",
        description: "超好用的设计稿预览工具，让您在移动设备上实时查看 Ps / Illustrator / Sketch / XD / Figma / MasterGo / 即时设计 中的设计图，稳定高效，提升你的工作体验",
        install: "开始使用",
        video: "观看演示视频",
        photoshop: "在Ps中进行预览，支持CC2018及以上版本，支持画布模式，即便是大长图也能够顺畅浏览",
        xd: "XD提供了桌面应用程序，能够实时监听到XD的内容变化，即便不用手机也可以在电脑上进行预览查看",
        sketch: "提供的Sketch插件，实时响应你的设计稿，预览功能更丰富，优于官方提供的预览工具",
        figma: "提供了桌面端，现在用Figma作图，也可以实时进行预览了，桌面，手机都能看",
        feature1: {
            title: "跨平台，多种设备支持",
            description: "Design Mirror支持多款主流设计软件，您可以在这些设计软件中享受相同的使用体验。移动端支持iPhone/Android设备，还支持微信小程序和web预览。让您再各种终端上感受设计的适配效果。",
            details: [
                "支持Windows/Mac操作系统",
                "支持 Photoshop / Illustrator / Sketch / XD / Figma / MasterGo / 即时设计",
                "支持iphone/android/小程序/web预览",
                "支持同时链接多个手机设备，查看不同设备的适配效果"
            ]
        },
        feature2: {
            title: "Wifi多设备连接",
            description: "将电脑和手机连接到相同的wifi环境下, 打开App即可快速连接预览。支持多个设备同时连接，您可以将多台手机、平板等设备同时连接，同步预览，同步刷新。独创的电脑和手机双向通信机制，不用手动关防火墙也能连。",
            details: [
                "自动识别设备，不用手动输入ip",
                "支持多个设备同时链接，手机、平板、浏览器，同步刷新",
                "不用登录，扫码就能连，快速让他人查看效果",
            ]
        },
        feature3: {
            title: "支持USB连接，稳定快速",
            description: "当wifi网络不稳定的时候，您还可以通过USB连接电脑来进行预览，不需要复杂的设置，点击按钮即可使用，方便快捷。USB传输的速度更快，一边给设备充电一边预览。",
            details: [
                "将移动设备通过USB线插入电脑即可",
                "支持win/mac系统，支持ios/android设备",
                "传输速度更快，更稳定，无网络下的救命稻草",
            ]
        },
        app: {
            title: "贴心的功能特性",
            description: "App提供了丰富多样的功能，帮助你提升工作效率",

            features: [
                {
                    title: "随心缩放，完美适配",
                    description: "支持双指缩放、原始尺寸、适配屏幕等多种缩放方式，达到最称心的适配效果"
                },
                {
                    title: "多文档/多画布切换",
                    description: "画布再多，也可以快速选择，可以滑动切换，就和看相册照片那样容易"
                },
                {
                    title: "截屏快照&图像对比",
                    description: "可以将预览图保存到手机上，还可以将前后的截图做对比，选更优的方案"
                },
                {
                    title: "上传手机图片",
                    description: "支持将手机上的图片上传到电脑端，直接设计软件打开，务必快捷，从此告别QQ传图"
                },
                {
                    title: "离线文档，随时可查看",
                    description: "预览过的文档会保存在手机上，随时随地可以翻出来查看"
                },
                {
                    title: "好设计，分享给他人",
                    description: "支持将图片分享到各大社交媒体，好作品让更多人看见"
                }
            ]

        },
        signup: {
            title: "现在就开始使用吧",
            description: "免费注册账号，享受多平台多终端丝滑体验",
            email: "请输入邮箱地址",
            button: "注册账号"
        },
        price: {
            title: "价格与购买方式",
            description: "新用户默认享有15天的免费试用，请确认好用后再购买，会员享受免费升级和开发者技术支持。",
            plans: [
                {
                    title: "体验套餐",
                    currency: "￥",
                    price: 35,
                    sku_id: 13,
                    type: 0,
                    period: "/半年",
                    feature: [
                        "不限平台/设计软件",
                        "技术支持，免费升级",
                        "限个人使用",
                        "发票开具",
                    ],
                    button: "购买",
                },
                {
                    title: "标准套餐",
                    currency: "￥",
                    sku_id: 14,
                    price: 60,
                    type: 0,
                    period: "/年",
                    feature: [
                        "不限平台/设计软件",
                        "技术支持，免费升级",
                        "限个人使用",
                        "发票开具",
                    ],
                    button: "购买",
                },
                {
                    title: "优惠套餐",
                    currency: "￥",
                    sku_id: 15,
                    type: 0,
                    price: 100,
                    isBest: true,
                    period: "/2年",
                    feature: [
                        "不限平台/设计软件",
                        "技术支持，免费升级",
                        "限个人使用",
                        "发票开具",
                    ],
                    button: "购买",
                },
                {
                    title: "多人团购",
                    currency: "折",
                    sku_id:14,
                    type: 2,
                    price: 80,
                    period: "%",
                    feature: [
                        "不限平台/设计软件",
                        "10人以上8折优惠",
                        "技术支持，免费升级",
                        "发票开具",
                    ],
                    button: "购买",
                },
                /*
                {
                    title: "企业用户",
                    currency: "",
                    sku_id:100,
                    price: 60,
                    period: "/年",
                    feature: [
                        "统一账号管理",
                        "不限平台/设计软件",
                        "10份以上8折优惠",
                        "提供定制支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                 */
            ],
            enterprise: {
                title: "企业/团队购买",
                description: "对于企业或者团队，可以通过购买团队授权，将提供统一的账号管理功能，可以方便的管理团队用户，同时也可以享受团购优惠（10份以上8折）。",
                price: "价格： 60￥/年/人",
                feature: [
                    "统一账号管理，方便管理团队用户",
                    "不限平台/设计软件",
                    "10份以上8折优惠",
                    "提供技术支持，免费升级",
                    "支持开具发票",
                ],
                button: "购买",
            }
        },
        price_11: {
            title: "价格与购买方式",
            description: "双十一优惠大酬宾！永久授权限时回归，限时优惠，不容错过！",
            plans: [
                {
                    title: "Photoshop",
                    currency: "￥",
                    price: 60,
                    sku_id: 3,
                    type: 0,
                    period: "/永久",
                    feature: [
                        "限Ps中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                {
                    title: "Sketch",
                    currency: "￥",
                    sku_id: 4,
                    price: 60,
                    type: 0,
                    period: "/永久",
                    feature: [
                        "限Sketch中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                {
                    title: "Adobe XD",
                    currency: "￥",
                    sku_id: 5,
                    type: 0,
                    price: 60,
                    period: "/永久",
                    feature: [
                        "限XD中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                {
                    title: "Figma",
                    currency: "￥",
                    sku_id:17,
                    type: 0,
                    price: 60,
                    period: "/永久",
                    feature: [
                        "限Figma中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
            ],
        },
        contact: {
            title: "如何联系我们",
            description: "当您遇到使用问题或者有其它疑惑的时候，您可以通过如下方式联系我们",
            follow_title: "关注我们",
            details: [
                {
                    title: "微信技术支持",
                    description: "用微信扫描下面二维码，添加技术支持企业微信。技术支持和问题解答将得到快速满足。",
                    more: "<img alt='wechat coporate' class='img-fluid' width='200' src='/images/index/wechat_qrcode_20260615.jpg'/>"
                },
                {
                    title: "微信公众号",
                    description: "用微信扫描下面二维码，关注官方公众号，公众号会不定期发布一些新产品，优惠活动等信息，千万不要错过。",
                    name: "wechat",
                    more: "<img alt='wechat coporate' class='img-fluid' width='200' src='/images/index/wechat-cutterman.jpg?202305'/>"
                },

                /*
                {
                    title: "帮助和反馈平台",
                    description: "使用帮助和问题反馈平台，在这里你可以找到常见的问题解决办法，你也可以在这里提出你的想法和建议",
                    more: "<a class='text-primary' target='_blank' href='https://support.qq.com/products/360031'>点击了解详情>></a>"
                },
                {
                    title: "QQ交流群",
                    description: "在这里可以和众多用户进行使用交流，或者其它话题交流，也有官方开发者进行技术支持",
                    name: "qq",
                    follow: "点击关注>>"
                },
                 */
            ]
        }
    },
    signup: {
        title: "注册新账号",
        email: "邮箱",
        emailTip: "请输入正确邮箱地址",
        password: "密码",
        passwordTip: "密码长度至少6位",
        accept: "我接受",
        terms: "用户服务协议",
        signup: "注册",
        captcha: "验证码",
        captcha_tip: "输入右侧验证码",
        refresh_captcha: "换一个",
        haveAccount: "已经拥有账号了？",
        signIn: "点我登录",
        token: {
            title: "最后一步！",
            description: "已向邮箱<span class='badge badge-info'>{email}</span>发送了一份验证码邮件，请打开邮箱，在下面填入该验证码，即可完成注册。",
            token_tip: "请输入6位验证码",
            done: "完成注册",
            resend_token: "重发验证码",
            resend_tip: "已重新发送<br/>60s后可以再次发送",
            success: "注册完成，即将跳转..."
        }
    },
    login: {
        title: "登录",
        email: "邮箱",
        emailTip: "请输入正确邮箱地址",
        password: "密码",
        passwordTip: "密码长度至少6位",
        forgot_pass: "忘记密码？",
        no_account: "还没有账号？",
        signup: "去注册",
        login_success: "登录成功，现在跳转...",
        modal: {
            title: "请登录您的账号"
        }
    },
    reset_pass: {
        title: "重置密码",
        description: "请输入您的邮箱地址，以获取密码重置验证码",
        emailSend: "已发送一封验证码邮件到邮箱<strong>{email}</strong>，请查收邮件并将验证码填入下面输入框中。",
        email: "邮箱",
        emailTip: "请输入正确邮箱地址",
        newPass: "新密码",
        send: "发送",
        submit: "提交",
        successTip: "密码重置成功！",
        remember: "想起了密码？",
        login: "去登录"
    },
    photoshop: {
        title: "Photoshop 插件安装",
        description: "在 Photoshop 里直接看到当前预览图和设备连接状态。",
        version_support: "同时支持 arm 和 intel 芯片，最低支持到 CC2018",
        download: "点击下载",
        version: "版本：",
        update_time: "更新时间：",
        install: {
            title: "安装指南",
            description: "一个安装包装好全部，三步开始预览",
            step1: {
                title: "下载并安装 Design Mirror",
                detail: "点击上方按钮下载 pkg（Mac）或 exe（Windows），双击一路下一步即可。Mac 需要输入电脑密码。安装包已通过 Apple 公证，不会再出现「无法验证开发者」的拦截。这一个安装包同时装好后台助手和 Photoshop、Sketch、XD、Illustrator 四个软件的面板，不需要再分别下载。"
            },
            step2: {
                title: "打开插件面板",
                detail: "重启 Photoshop，从 菜单栏 -> 窗口 -> 扩展 里找到 Design Mirror 打开面板，登录账号即可。\n如果这里找不到（新版 Photoshop、尤其是苹果芯片的 Mac 上很常见），请改到 菜单栏 -> 插件 里找 Design Mirror——Adobe 从 2022 版起把扩展入口挪到了那里，两个位置只会出现一个。\n后台助手随开机自启，平时不需要管它。"
            },
            step3: {
                title: "手机连接",
                detail: "手机装上 Design Mirror App（4.0 及以上），和电脑处在同一 Wi-Fi 下会自动发现；网络不通时可以用面板上的二维码扫码，或直接插 USB 线。"
            }
        }
    },
    sketch: {
        title: "Sketch 插件安装",
        description: "在 Sketch 里直接预览，不再需要官方预览 App。",
        version_support: "* 支持所有 Sketch 版本，无需按版本挑安装包",
        download: "点击下载",
        install: {
            step1: {
                title: "安装并打开插件",
                detail: "下载到的是一个 pkg 安装程序（不是 .sketchplugin 文件），双击一路下一步即可。安装包已通过 Apple 公证，不会被系统拦截。装完重启 Sketch，从 菜单栏 -> 插件 -> Design Mirror 打开面板，登录账号即可开始使用。\n4.0 的插件不再按 Sketch 版本区分，新老版本用同一个安装包，不需要再去找对应版本的下载链接。\n同一个安装包也装好了 Photoshop、XD、Illustrator 的面板，不需要另外下载。"
            }
        }
    },
    xd: {
        title: "Adobe XD 插件安装",
        description: "XD 一样可以实时预览。",
        version_support: "* 建议使用最新版本的 XD",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'xd']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载 Design Mirror 安装包，双击安装。<strong>4.0 起 XD 插件已包含在安装包内，不再需要单独下载 .xdx 文件。</strong> 装完就好，<strong>不需要打开任何窗口</strong>——4.0 的助手是后台服务，随开机自动运行（旧版需要一直开着桌面客户端，新版不用了）。",
                "重启 XD，从 菜单栏 -> 插件 -> Design Mirror 打开面板",
                "手机装上 Design Mirror App（4.0 及以上），同一 Wi-Fi 下会自动发现，也可以扫面板上的二维码"
            
            ],
            step: {
                title: "下载并安装",
                detail: "一个安装包同时装好后台助手和 XD 插件；Photoshop、Sketch、Illustrator 的面板也一并装好了。"
            }
        }
    },
    illustrator: {
        title: "Illustrator 插件安装",
        description: "4.0 新增支持 Adobe Illustrator，在 AI 里也能实时预览到手机上。",
        version_support: "支持 Illustrator CC2014 及以上版本",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "点击上方按钮下载 Design Mirror 安装包，双击一路下一步即可。<strong>Illustrator 插件已包含在安装包内，不需要单独下载。</strong>",
                "重启 Illustrator，从 菜单栏 -> 窗口 -> 扩展 中找到 Design Mirror 打开面板，登录账号即可",
                "手机装上 Design Mirror App（4.0 及以上），和电脑处在同一 Wi-Fi 下会自动发现；也可以扫面板上的二维码，或直接插 USB 线"
            ]
        }
    },
    figma: {
        title: "Figma插件安装",
        description: "没错，现在用Figma也支持使用Design Mirror进行预览了",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://www.figma.com/community/plugin/1021010214021436737/Design-Mirror\">点击这里 <i class=\"uil uil-external-link-alt\"></i></a> 从官方插件市场安装Figma插件",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'figma']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载电脑端的 Design Mirror 助手（已升级到 4.0），双击安装。装完就好，<strong>不需要打开任何窗口</strong>——4.0 的助手是后台服务，随开机自动运行（旧版需要一直开着桌面客户端，新版不用了）。",
                "打开 Figma 插件，手机装上 Design Mirror App（4.0 及以上），同一 Wi-Fi 下会自动连上"
            ]}
    },
    jsdesign: {
        title: "即时设计插件安装",
        description: "支持国产！优秀的设计软件<strong>即时设计</strong>也可以使用Design Mirror进行预览了",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://js.design/community?category=detail&type=plugin&id=641aed2ff131d9846a1f1edc\">点击这里 <i class=\"uil uil-external-link-alt\"></i></a> 从官方插件市场安装插件",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'jsdesign']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载电脑端的 Design Mirror 助手（已升级到 4.0），双击安装。装完就好，<strong>不需要打开任何窗口</strong>——4.0 的助手是后台服务，随开机自动运行（旧版需要一直开着桌面客户端，新版不用了）。",
                "打开即时设计插件，手机装上 Design Mirror App（4.0 及以上），同一 Wi-Fi 下会自动连上"
            ]}
    },
    mastergo: {
        title: "Mastergo插件安装",
        description: "在<strong>Mastergo</strong>设计软件上使用Design Mirror",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://mastergo.com/community/plugin/88358893523396\">点击这里 <i class=\"uil uil-external-link-alt\"></i></a> 从官方插件市场安装插件",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'mastergo']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载电脑端的 Design Mirror 助手（已升级到 4.0），双击安装。装完就好，<strong>不需要打开任何窗口</strong>——4.0 的助手是后台服务，随开机自动运行（旧版需要一直开着桌面客户端，新版不用了）。",
                "打开 MasterGo 插件，手机装上 Design Mirror App（4.0 及以上），同一 Wi-Fi 下会自动连上"
            ]}
    },
    mobile: {
        title: "手机 App 下载",
        description: "支持 iPhone / Android 和微信小程序，也可以直接用手机浏览器扫码预览。<br/><br/><strong>请务必更新到 4.0 及以上版本</strong>——4.0 的电脑端换了新的连接机制（局域网 / 云端信令 / 扫码 / USB 自动切换），旧版 App 连不上。各大应用市场搜索 <strong>design mirror</strong> 即可。",
        modal: {
            title: "App 下载",
            detail: "在 App Store 搜索 <strong>Design Mirror</strong> 安装，或点击下方按钮直接前往。请确认版本为 <strong>4.0 及以上</strong>。<br/>安卓请用上一页的 <strong>Android App</strong> 按钮下载。",
            appstore: "前往 App Store"
        },
        feature: {
            title: "功能特性",
            description: "App 提供了丰富且易用的功能，让您的实时预览更方便"
        }
    },
    buy: {
        title: "价格与购买",
        description: "新用户可以享受15天的免费试用，试用期间可以体验完整功能，以让您对这个产品有足够&全面的了解。当认为它对您有帮助之后，可以选择付费购买更长时间的使用权益。",
        member_tip_title: "老用户权益变更",
        member_tip: "从2022/5/1日起，本产品由原先的单平台终身付费方式，改为全平台支持订阅付费制，已购买单平台终身制的用户请<a class='badge badge-light' href=\"/member-update\">点击这里</a>查看权益变更细则。"
    },
    help: {
        title: "帮助与支持",
        list: [
            {
                title: "快速开始",
                id: "quickstart",
                detail: [
                    "从安装到在手机上看到设计稿，一共四步，几分钟就能走完。",
                    "<strong>1. 安装桌面端</strong>",
                    "到 <a href='/v4'>下载页</a> 选择对应系统的安装包（Windows 为 .exe，macOS 为 .pkg），双击运行一路下一步即可。<strong>Photoshop / Illustrator / Sketch / Adobe XD 四款软件的插件和后台连接助手会一次性自动装好</strong>，不需要再逐个下载。",
                    "<strong>2. 手机安装 App</strong>",
                    "iPhone 在 App Store 搜索「Design Mirror」安装，需要 iOS 17.0 及以上系统；Android 用<strong>手机浏览器</strong>打开蒲公英下载页安装（用微信扫码会打不开，这是微信的限制）。",
                    "<strong>3. 打开设计软件的插件面板</strong>",
                    "安装完桌面端后要<strong>重启设计软件</strong>，插件菜单才会出现。各软件的入口见下方对应章节。",
                    "<strong>4. 连接并开始预览</strong>",
                    "手机和电脑连到同一网络，打开 App 会自动发现你的电脑，点一下即可连上。网络环境复杂时会自动切换到云端通道，也可以扫码或插 USB 数据线连接。",
                    "Figma、MasterGo、即时设计这三款的插件从各自的官方插件市场安装，其余步骤一样，详见下面各自的章节。",
                ]
            },
            {
                title: "手机 App 安装",
                id: "app",
                detail: [
                    "<strong>iPhone / iPad</strong>",
                    "已在 App Store 上架，直接搜索「Design Mirror」安装即可，需要 iOS 17.0 及以上系统。",
                    "<strong>Android</strong>",
                    "通过蒲公英分发，请到 <a href='/mobile'>App 下载页</a> 获取链接。",
                    "<strong style='color: red'>注意：必须用手机自带的浏览器打开下载链接。</strong>微信内置浏览器会拦截应用下载，扫码后页面打不开是正常的，把链接复制到浏览器即可。",
                    "安装时如果系统提示「未知来源」或「外部来源应用」，需要在弹窗里允许安装，这是 Android 对非应用商店渠道的常规提示。",
                    "<strong>App 需要哪些权限</strong>",
                    "只需要本地网络权限，用于发现同一网络下的电脑。如果 App 首页的 IP 显示为 0.0.0.0，通常就是网络权限没给或没连上 Wi-Fi，请到系统设置里检查。",
                ]
            },
            {
                title: "Photoshop 插件",
                id: "ps",
                detail: [
                    "<strong>安装</strong>",
                    "插件包含在桌面端安装包里，装完桌面端就已经装好了，<strong>不需要单独下载 Photoshop 插件</strong>。",
                    "<strong style='color: red'>macOS 首次安装时如果弹出「无法打开，因为它来自身份不明的开发者」</strong>，是系统对第三方开发者的默认限制，打开 系统设置 → 隐私与安全性 → 安全性，点击底部的「仍要打开」即可。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_2.png\" alt=\"macOS 提示无法打开来自身份不明开发者的安装包\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_3.png\" alt=\"在 macOS 安全性设置中点击仍要打开\" />",
                    "<strong>打开插件面板</strong>",
                    "重启 Photoshop，从 菜单栏 → 窗口 → 扩展（部分版本叫「增效工具」）→ Design Mirror 打开面板。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_4.png\" alt=\"在 Photoshop 窗口菜单的扩展中打开 Design Mirror 面板\" />",
                    "面板打开后登录账号即可开始预览。<strong>预览期间请保持面板处于打开状态</strong>，关掉面板就会断开。",
                    "<strong>找不到「扩展」菜单？</strong>",
                    "较新版本的 Photoshop 把旧版扩展入口挪到了 菜单栏 → 增效工具 下，先到那里找一找。如果两个位置都没有，说明插件没装上，请重新运行一次桌面端安装包。",
                ]
            },
            {
                title: "Illustrator 插件",
                id: "ai",
                detail: [
                    "Illustrator 的支持是 4.0 版本新增的，用法和 Photoshop 基本一致。",
                    "<strong>安装</strong>",
                    "插件同样包含在桌面端安装包里，装完桌面端即可，不需要单独下载。",
                    "<strong>打开插件面板</strong>",
                    "重启 Illustrator，从 菜单栏 → 窗口 → 扩展（或「增效工具」）→ Design Mirror 打开面板。",
                    "登录账号后即可把当前画板实时预览到手机上。预览期间请保持面板打开。",
                    "更详细的图文步骤见 <a href='/illustrator'>Illustrator 安装页</a>。",
                ]
            },
            {
                title: "Sketch 插件",
                id: "sketch",
                detail: [
                    "Sketch 插件最低支持 <strong>Sketch 70</strong>，支持 Apple Silicon（M 系列）芯片的 Mac。",
                    "<strong>安装</strong>",
                    "插件包含在 macOS 桌面端安装包里，装完桌面端就已经装好了。",
                    "<strong style='color: red'>注意：这个插件是通过 .pkg 安装程序安装的，不是常见的 *.sketchplugin 格式</strong>，所以不用（也不能）拖进 Sketch 的插件目录。",
                    "如果安装时提示无法打开，同样是 macOS 的开发者限制，到 系统设置 → 隐私与安全性 → 安全性 点击「仍要打开」。",
                    "<strong>打开插件面板</strong>",
                    "重启 Sketch，从 菜单栏 → 插件 → Design Mirror 打开面板。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_9.png\" alt=\"在 Sketch 插件菜单中打开 Design Mirror\" />",
                    "登录账号后即可开始预览。<strong>预览期间请保持面板打开</strong>，用完可以关掉。",
                    "更详细的图文步骤见 <a href='/sketch'>Sketch 安装页</a>。",
                ]
            },
            {
                title: "Adobe XD 插件",
                id: "xd",
                detail: [
                    "<strong>安装</strong>",
                    "插件包含在桌面端安装包里，装完桌面端即可。",
                    "<strong>打开插件面板</strong>",
                    "重启 Adobe XD，从 菜单栏 → 插件 → Design Mirror 打开面板。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_11.png\" alt=\"打开 Design Mirror 桌面客户端\" />",
                    "登录账号后即可开始预览，预览期间请保持面板打开。",
                    "更详细的图文步骤见 <a href='/xd'>XD 安装页</a>。",
                ]
            },
            {
                title: "Figma 插件",
                id: "figma",
                detail: [
                    "Figma 的插件已上架官方插件市场，装好插件和电脑端助手就能用，<strong>浏览器版和桌面客户端都可以</strong>。",
                    "<strong>1. 从插件市场安装插件</strong>",
                    "<a href='https://www.figma.com/community/plugin/1021010214021436737/Design-Mirror' target='_blank' rel='noopener'>打开 Figma 官方插件市场页面</a>，点击安装即可。",
                    "<strong>2. 安装电脑端助手</strong>",
                    "到 <a href='/v4'>下载页</a> 下载并安装 Design Mirror 桌面端（4.0 及以上）。装完就行，<strong>不需要开着任何窗口</strong> —— 4.0 起助手是随开机自动运行的后台服务，插件通过它和手机通信。",
                    "<strong>3. 开始预览</strong>",
                    "在 Figma 中打开 Design Mirror 插件并登录账号，手机装上 Design Mirror App（4.0 及以上），同一 Wi-Fi 下会自动连上。",
                    "预览期间请保持插件面板打开，关掉面板会断开连接。",
                    "更详细的图文步骤见 <a href='/figma'>Figma 安装页</a>。"
                ]
            },
            {
                title: "MasterGo 插件",
                id: "mastergo",
                detail: [
                    "MasterGo 的插件已上架官方插件市场，装好插件和电脑端助手就能用，<strong>浏览器版和桌面客户端都可以</strong>。",
                    "<strong>1. 从插件市场安装插件</strong>",
                    "<a href='https://mastergo.com/community/plugin/88358893523396' target='_blank' rel='noopener'>打开 MasterGo 官方插件市场页面</a>，点击安装即可。",
                    "<strong>2. 安装电脑端助手</strong>",
                    "到 <a href='/v4'>下载页</a> 下载并安装 Design Mirror 桌面端（4.0 及以上）。装完就行，<strong>不需要开着任何窗口</strong> —— 4.0 起助手是随开机自动运行的后台服务，插件通过它和手机通信。",
                    "<strong>3. 开始预览</strong>",
                    "在 MasterGo 中打开 Design Mirror 插件并登录账号，手机装上 Design Mirror App（4.0 及以上），同一 Wi-Fi 下会自动连上。",
                    "预览期间请保持插件面板打开，关掉面板会断开连接。",
                    "更详细的图文步骤见 <a href='/mastergo'>MasterGo 安装页</a>。"
                ]
            },
            {
                title: "即时设计插件",
                id: "jsdesign",
                detail: [
                    "即时设计 的插件已上架官方插件市场，装好插件和电脑端助手就能用，<strong>浏览器版和桌面客户端都可以</strong>。",
                    "<strong>1. 从插件市场安装插件</strong>",
                    "<a href='https://js.design/community?category=detail&type=plugin&id=641aed2ff131d9846a1f1edc' target='_blank' rel='noopener'>打开 即时设计 官方插件市场页面</a>，点击安装即可。",
                    "<strong>2. 安装电脑端助手</strong>",
                    "到 <a href='/v4'>下载页</a> 下载并安装 Design Mirror 桌面端（4.0 及以上）。装完就行，<strong>不需要开着任何窗口</strong> —— 4.0 起助手是随开机自动运行的后台服务，插件通过它和手机通信。",
                    "<strong>3. 开始预览</strong>",
                    "在 即时设计 中打开 Design Mirror 插件并登录账号，手机装上 Design Mirror App（4.0 及以上），同一 Wi-Fi 下会自动连上。",
                    "预览期间请保持插件面板打开，关掉面板会断开连接。",
                    "更详细的图文步骤见 <a href='/jsdesign'>即时设计 安装页</a>。"
                ]
            },
            {
                title: "连不上怎么办（Wi-Fi）",
                id: "wifi",
                detail: [
                    "V4 会按 局域网发现 → 云端通道 → 扫码 → USB 的顺序自动尝试，多数情况下不需要手动干预。如果始终连不上，按下面的顺序排查。",
                    "<strong>1. 先确认插件本身是正常的</strong>",
                    "打开插件面板，如果面板里能正常显示设计图，说明插件工作正常，继续往下看。如果面板里就是空的或报错，多半是插件没装好，重新运行一次桌面端安装包。",
                    "如果面板提示<strong>没有连接到设计软件</strong>，常见原因是本机开了 VPN 或网络代理，请关闭后重启设计软件；没开代理的话，先关闭插件面板再重启设计软件。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_14.png\" alt=\"插件面板提示未连接到设计软件\" />",
                    "<strong>2. 确认手机和电脑在同一个网络</strong>",
                    "对比 App 首页显示的 IP 和电脑的 IP。",
                    "<strong style='color: red'>注意跨网段的情况：</strong>有时两台设备连的是同一个 Wi-Fi 名称，但被分配到了不同的路由器或网段，例如电脑是 192.168.<strong>0</strong>.10、手机是 192.168.<strong>1</strong>.12，第三段不同就是跨网段，这种情况下局域网发现会失败。",
                    "如果 App 首页 IP 显示为 <strong>0.0.0.0</strong>，说明手机没有连上 Wi-Fi（可能在用移动网络），或者 App 没拿到本地网络权限。请检查系统设置里的网络权限，然后重新开关一次 Wi-Fi 并重启 App。",
                    "<strong>3. 改用扫码连接</strong>",
                    "跨网段或自动发现失败时，用 App 扫描插件面板上的二维码，可以直接建立连接，不依赖局域网发现。",
                    "<strong>4. 手动输入 IP</strong>",
                    "在 App 尝试连接的过程中，也可以在插件面板上手动填入手机显示的 IP 进行连接。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_15.png\" alt=\"在插件面板中手动输入手机 IP 进行连接\" />",
                    "<strong>5. 检查电脑防火墙</strong>",
                    "Windows 防火墙有时会拦截其它设备的连入，可以临时关闭防火墙测试；确认是防火墙的问题后，建议改为放行 Design Mirror 而不是一直关着防火墙。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_16.png\" alt=\"Windows 防火墙设置\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_17.png\" alt=\"在 Windows 防火墙中放行应用\" />",
                    "<strong>6. 改用 USB 连接</strong>",
                    "公司或学校网络常常开启了「客户端隔离」，即使在同一网段，设备之间也无法互相通信。这种环境下局域网连接不可能成功，请直接用 USB 数据线连接，方法见下一节。",
                ]
            },
            {
                title: "连不上怎么办（USB）",
                id: "usb",
                detail: [
                    "没有可用 Wi-Fi、或者网络做了隔离时，用数据线连接是最可靠的方式。",
                    "<strong>先确认版本</strong>",
                    "软件在持续更新，你遇到的问题可能已经修复了，请先确认桌面端和手机 App 都是最新版本。",
                    "<strong>Windows + Android</strong>",
                    "这是最常见的组合，连不上大多是电脑没有识别出手机。",
                    "1. 在手机上打开<strong>开发者选项</strong>里的 <strong>USB 调试</strong>。开启方法各品牌略有差异，通常是：设置 → 关于手机 → 连续点击「版本号」7 次解锁开发者选项，再到 设置 → 系统 → 开发者选项 中打开 USB 调试。",
                    "2. 连上数据线后，手机会弹出「是否允许 USB 调试」的授权框，需要点击允许。这个弹窗只在首次连接某台电脑时出现，如果没看到，请拔插一次数据线。",
                    "3. 如果仍然识别不出来，可以装一个手机厂商的官方助手软件验证一下电脑能否识别手机——助手能识别，Design Mirror 通常也能连上。",
                    "<strong style='color: red'>注意：部分第三方手机助手会独占 USB 调试通道，导致其它程序连不上手机。</strong>如果电脑上装了这类软件，请先退出它再试。",
                    "4. 换一根数据线试试。很多线只能充电、不能传输数据，这是排查中最容易被忽略的一点。",
                    "<strong>Windows + iPhone</strong>",
                    "Windows 需要借助 Apple 的驱动才能识别 iPhone。",
                    "在较新的 Windows 上，请到 Microsoft Store 安装 <strong>Apple 设备</strong>（Apple Devices）应用；较旧的系统仍然使用 iTunes，可从 <a href='https://www.apple.com.cn/itunes/' target='_blank' rel='noopener'>苹果官网</a> 下载。",
                    "安装后打开一次，让它识别到你的手机（识别成功时界面上会出现手机图标），之后连接时<strong>不需要保持它开着</strong>。",
                    "如果之前装过但识别不出来，重装一次通常可以解决。",
                    "首次用数据线连接时，iPhone 上会弹出「要信任此电脑吗？」，必须点击<strong>信任</strong>并输入锁屏密码。",
                    "<strong>macOS + iPhone / Android</strong>",
                    "macOS 不需要额外安装驱动。如果连不上，优先怀疑数据线或接口，换一根线、换一个口再试。iPhone 首次连接同样需要在手机上点「信任此电脑」。",
                ]
            },
            {
                title: "账号与设备",
                id: "account",
                detail: [
                    "<strong>1. 需要注册账号吗？</strong>",
                    "需要。插件面板和手机 App 都要登录同一个账号才能配对，可以在 <a href='/auth-signup'>注册页</a> 用邮箱注册。",
                    "<strong>2. 一个账号可以在几台设备上使用？</strong>",
                    "订阅是按账号授权的，可以在 <a href='/profile'>个人中心</a> 查看和管理已登录的设备，不再使用的设备可以移除。",
                    "<strong>3. 可以同时连接多部手机吗？</strong>",
                    "可以。一台电脑能同时连接多部手机或平板，方便并排比较不同尺寸机型上的显示效果。",
                    "<strong>4. 忘记密码了怎么办？</strong>",
                    "到 <a href='/auth-re-password'>找回密码页</a> 用注册邮箱重置即可。",
                ]
            },
            {
                title: "付费相关问题",
                id: "pay",
                detail: [
                    "<strong>1. 这个软件是收费的吗？</strong>",
                    "是的。新账号有 15 天试用期，试用期内功能和付费后完全一致，用着合适再购买。",
                    "<strong>2. 收费模式是什么样的？</strong>",
                    "采用订阅制授权，试用到期后需要购买才能继续使用。订阅分半年、一年、两年三档，10 人以上团购有折扣。",
                    "<strong>订阅不区分设计软件</strong>——订阅期内 Photoshop / Illustrator / Sketch / Adobe XD / Figma / MasterGo / 即时设计 全部可用，也不限制 Windows 或 macOS。",
                    "<strong>3. 会员有什么权益？</strong>",
                    "除了完整功能之外，还包含后续版本免费升级，以及会员专属的技术支持与优先处理。遇到连不上这类问题可以直接找到开发者，不用干等。",
                    "<strong>4. 如何购买？</strong>",
                    "点击导航栏的「购买」进入 <a href='/buy'>购买页</a>，选择合适的套餐即可。目前支持支付宝支付。",
                    "<strong>5. 可以开发票吗？</strong>",
                    "可以，各档套餐均支持开具发票，购买后联系客服办理。",
                    "<strong>6. 团队采购怎么处理？</strong>",
                    "10 人以上可享团购折扣，详见 <a href='/team'>团队购买页</a>，也可以直接联系我们。",
                ]
            },
            {
                title: "联系技术支持",
                id: "contact",
                detail: [
                    "<strong>没找到答案？直接联系开发者</strong>",
                    "上面的排查步骤都试过还是不行，或者你有功能上的建议，欢迎直接找我。微信扫码添加时请备注「Mirror」，方便我第一时间定位问题。",
                    "<img alt='Design Mirror 官方微信二维码' class='img-fluid' width='200' src='/images/index/wechat_qrcode_20260615.jpg'/>",
                    "如果二维码无法识别，也可以邮件联系：<a href='mailto:xiaoqiang@cutterman.cn'>xiaoqiang@cutterman.cn</a>",
                    "反馈问题时，如果能附上你的<strong>操作系统版本、设计软件版本、手机型号</strong>，以及插件面板或 App 上的报错截图，定位会快很多。",
                ]
            },
        ]
    },

    member: {
        title: "权益变更说明",
        description: "针对已购买过终身授权的用户",
        overview: {
            title: "变更说明：",
            content: "至<b class='text-danger'>2022年5月1日</b>起，Design Mirror授权方式，从之前的<strong class='text-primary'>单平台终身授权</strong>更换为<strong class='text-primary'>全平台订阅授权</strong>方式。对于已经购买过某平台下终身授权的用户，涉及到已购买的授权是否发生变化和将要购买其它平台时如何付费等问题，下文将详细说明。",
            title1: "名词解释",
            content1: "<b>单平台终身授权</b>指的是每个平台(Ps/Sketch/XD/Figma）需要单独购买，一次购买终身使用。",
            content2: "<b>全平台订阅授权</b>指的是按照时间订阅的方式进行购买授权，购买后该账号在<b>全部设计软件</b>上都可以使用，不限平台（Ps / Illustrator / Sketch / XD / Figma / MasterGo / 即时设计）。",
            title3: "已购的授权是否有效？",
            content3: "已经购买过的终身授权，继续有效，仅对该平台终身有效。",
            title4: "购买其它平台如何授权？",
            content4: "购买新平台的授权，将采用订阅授权的方式，订阅授权针对所有剩余未购买的平台有效。",
            title5: "老用户优惠政策",
            content5: "为感谢老用户信任与支持，对已购买过某平台授权的用户，购买其它平台订阅授权享受首年优惠政策：",
            desc1: "1. 已经购买了Ps&Sketch&XD三个平台终身授权的用户，不再需要购买Figma，自动终身使用",
            desc2: "2. 已经购买了任意两个平台终身授权的用户，购买剩余两个平台的订阅授权，首年享受<b class='text-danger'>4折优惠</b>",
            desc3: "3. 已经购买了任意一个平台终身授权的用户，购买剩余三个平台的订阅授权，首年享受<b class='text-danger'>6折优惠</b>",
            desc4: "4. 2/3两个优惠政策，仅针对<b class='text-danger'>标准套餐</b>有效"
        },
        faq: {
            title: "常见问题：",
            list: [
                {
                    q: "我已经购买了Ps的终身授权，是不是也要变成订阅按年付费？",
                    a: "不会，已经购买过的终身授权，依然有效。",
                },
                {
                    q: "我已经购买了Ps的终身授权，购买Sketch是否要按年付费？是否会影响我的Ps终身授权？",
                    a: "购买新的平台，都将采用订阅付费方式，但不会影响已购买的终身授权平台。即 Ps 依然终身使用，新购买的订阅授权对其余全部设计软件生效。",
                },
                {
                    q: "我已经购买了Ps和Sketch和XD三个平台的终身授权，是否还需要购买Figma？",
                    a: "不用，为感谢用户的支持，已经购买过3个平台终身授权的用户，自动赠送Figma的终身授权。",
                },
                {
                    q: "我购买了的账号，可以和别人共用么？",
                    a: "不能，账号仅自己使用，一个账号会有登录设备的限制，超过设备登录会导致功能无法连接，账号被列入异常等。",
                }
            ]
        }

    },
    cart: {
        title: "订单确认",
        param_error: "参数错误",
        order: {
            name: "商品名称",
            description: "描述",
            price: "价格",
            number: "份数",
            created_at: "创建时间",
            total: "总计",
            checkout: "支付宝付款",
            not_exists: "订单没有找到，即将跳转到购买页面"
        },
        group_order: {
            title: "团购账号信息",
            name: "一年期授权",
            email: "账号",
            add: "请添加团购用户的邮箱",
            add_button: "添加",
            remove: "删除"
        },
        org: {
            title: "添加组织成员",
            add: "请添加组织成员的邮箱",
            add_info: "1. 成员账号可以不用预先注册，也不需要保证真实存在，不能添加已经存在的账号，如需要请联系我们处理。<br/>2. 只针对子账号进行授权，当前账号默认为管理员账号，不做软件授权。<br/>3. 组织成员至少需要存在两个及以上。",
            name: "请为组织设置一个名称",
            submit: "提交",
            count: "购买数量",
            count_tip: "组织授权数量不能少于2个",
            auth_owner: "授权当前账号",
            auth_tip: "* 购买后会自动生成指定数量的子账号，不授权当前购买的账号",
            email_suffix: "邮箱后缀",
            email_tip: "可以为子账号设置统一的邮箱后缀",
        },
        pay_modal_title: "请使用支付宝扫码支付",
        status_title: "支付状态确认",
        status_success: "已完成支付",
        status_fail: "支付遇到问题",
        repay: "重新支付",
        success: {
            title: "购买成功！",
            detail: "感谢您的支持，我们会持续为您的效率提升而努力，您可以关注我们的公众号，微博以及时获取软件的更新和优惠活动信息。如果您遇到了使用问题，可以加入我们的官方QQ群寻求技术支持。",
        },
        fail: {
            title: "订单未支付",
            detail: "如果您在支付时遇到问题，或者支付完成了依然没有授权，请即刻通过下面的反馈渠道联系我们。",
        },
        home: "返回首页",
        qq: "官方QQ群",
        weixin: "微信公众号",
        weibo: "官方微博"
    },
    profile: {
        email_invalid: "您的邮箱还没有经过验证，请在<a href='javascript:void(0)' class='badge badge-dark'>设置界面</a>进行验证。",
        info: {
            title: "基本信息",
            description: "这里是您账号的基本信息，如果需要修改账号信息，请在<strong>设置</strong>TAB中进行修改。",
            email: "邮箱",
            status: {
                title: "账号状态",
                non_active: "邮箱未验证",
                non_active_tip: "请在设置tab进行邮箱有效性验证",
                active: "正常",
                block: "被锁定",
                block_tip: "账号已被锁定，请联系官方处理"
            },
            name: "名称",
            phone: "手机号",
            no_phone: "未设置",
            no_phone_tip: "设置后可以用手机号登录，找回账号等",
        },
        profit: {
            title: "权益",
            description: "这里显示的是您当前拥有的软件使用权益情况。",
            app: "App",
            auth_status: "权益状态",
            auth_trial: "试用期",
            auth_expired: "已过期",
            auth_subscribe: "已订阅",
            auth_lifetime: "永久使用授权",
            end_time: "到期时间",
            purchase_time: "授权时间"
        },
        order: {
            title: "订单",
            description: "以下是您购买的订单信息，",
            ticket: "需要开具发票？",
            ticket_title: "如何开具发票",
            ticket_detail: "微信扫描二维码加入官方群，联系群主开具发票。",
            id: "订单号",
            name: "名称",
            detail: "详细",
            price: "价格",
            created_at: "时间",
            status: "状态",
            buyer: "付款人",
            operation: "操作",
            pay: "去支付",
            delete: "删除",
            status_0: "未支付",
            status_1: "已支付",
            status_2: "支付中",
            status_3: "已关闭",
            status_4: "退款/转移",
        },
        device: {
            title: "设备",
            description: "显示您账号登录过的电脑设备信息，由于账号有设备登录数量限制，当超过数量之后，您可以在这里进行设备的删除操作。<span class='badge badge-pill badge-info'>名称标识</span>可以用来标记这台设备以便于理解，您可以按需要自行定义。",
            app: "App",
            os: "系统",
            mac: "MAC/IP地址",
            created_at: "时间",
            name: "名称标识",
            op: "操作",
            remove: "删除",
            modal_ok: "提交",
            modal_title: "自定义名称标识",
            name_tip: "名称标识必须由英文字母和数字组成，特殊字符可以有(-_.@#)",
            format_error: "名称格式不正确"
        },
        enterprise: {
            title: "组织",
            description: "这里显示的是您当前所在的组织信息，以及该组织下的成员。您可以对组织下的成员进行管理，包括添加、删除、修改等操作。",
            name: "组织名称",
            members: "成员列表",
            save: "保存",
            quota: "配额 (已用/总共)",
            add_quota: "增加配额",
            email: "账号",
            password: "密码",
            last_access_time: "最近使用时间",
            action: "操作",
            cancel: "取消"
        },
        setting: {
            title: "设置",
            email: "邮箱",
            email_tip: "* 修改邮箱后需要重新验证",
            name: "用户名",
            phone: "手机号",
            avatar: "头像",
            save: "保存修改",
            select_avatar: "选择头像",
            upload_avatar: "上传头像",
            change_password: "修改密码",
            new_password: "新密码",
            new_password_repeat: "再次输入密码",
            save_password: "保存密码",
            password_tip: "密码至少6位",
            select_done: "选好了",
            select_cancel: "取消",
            upload: "完成",
            upload_tip: "点击/拖拽图片到这里(<1M)",
            password_info: "* 密码修改后，各终端登录状态会被踢出",
            email_validate: "邮箱验证",
            email_validate_tip: "您的邮箱需要验证才能继续使用",
            send_code: "发送验证码",
            code_input_tip: "验证码已发送至邮箱<span class='badge badge-info badge-pill'>{email}</span>，请打开邮箱查看，并在下面填写6位验证码完成验证。如果没有收到邮件，请确认邮箱地址是否正确或者尝试重新发送。",
            code_submit: "验证",
            code_resend: "重发验证码"
        },
        logout: {
            title: "退出登录"
        }
    },
    terms: {
        title: "服务协议",
        time: "更新时间： 2022年2月7日",
        description: ["Design Mirror是由北京灵动无线网络科技有限公司(以下简称“灵动无线” 或“我们”)提供的互联网软件服务(以下简称“本产品”)。本服务协议(以 下简称“本协议”)是您(以下简称“您”或“用户”)与灵动无线之间关于您访问和使用Desing Mirror以及灵动无线提供的其他服务的协议。", "在本服务创建账户并使用之前，您必须首先同意本协议。在接受本协议之前， 请您仔细阅读全部内容，如您无法准确理解或不同意本协议的任一内容，请不要访问、使用我们提供的其他任何服务。您通过网络⻚面点击确认、 实际购买或使用本服务等操作均表示您已阅读并充分理解本协议之内容，具有达成本协议所需的民事权利能力和民事行为能力(或您符合本协议中“青少年特别协议”部分的要求)，与灵动无线就使用或订购相应产品和/或服务已达成合作意向，并同意接受本协议的全部约定内容，受其约束。","特别提示您关注本协议关于限制、免除灵动无线责任的协议、对用户的权利限制协议、违规/违约行为的认定处理、以及管辖法院的选择等协议内容，前述协议可能以加粗及/或加下划线形式提示您注意。", "您同意灵动无线有权不时地对本协议进行修订。修订后的协议将在网⻚上公布的方式向您告知，并代替原来的服务协议。您继续访问和使用本产品即视为您接受修订后的服务协议。如您不同意修订后的全部或者部分服务协议内容，您有权通过停止访问本网站或者拒绝使用相应软件服务等方式以终止服务协议或者使修订后的内容不对您生效。", "如果您代表某个机构而非您个人注册、登录和使用本产品，则您将被认为获得该机构的充分授权，有权代表该机构同意本服务协议以及服务协议不时的修改和补充。"],
        content: [
            {
                title: "服务内容",
                content: [
                    "本协议中的“本产品”指:灵动无线向您提供www.designmirror.cn网站(即官网)上所展示的产品和服务，包括但不限于通过网⻚、移动端APP等方式提供的全部服务，具体服务内容以您所使用或订购的内容为准。",
                    "若您未从灵动无线官方途径获取服务的，我们无法保证该服务能够正常使用，我们对此种获取方式和使用行为造成的损失不承担任何责任。",
                    "根据实际需要和灵动无线不时提供的其他服务内容，我们可能与您另行签订其他协议(“其他协议”)。同时，即使未另行签订其他协议，您使用本产品的具体服务也将被视为您同意我们关于该等具体服务的任何要求。如果其他协议和本协议之间存在冲突，应以其他协议为准，但以该冲突和与该协议特定事宜相关为限。",
                    "灵动无线保留随时变更、中止或终止部分免费服务的权利，并保留根据实际情况随时调整本产品提供的免费服务种类、形式的权利。灵动无线不承担因本产品提供的任何免费服务的调整给您造成的损失。灵动无线有权在未来恰当的时机对任何免费服务内容收取相应的服务费用。灵动无线做出上述调整前会以站内通知、邮件或官网公告等方式通知您，并给予您合理期限以完成数据的下载和备份。免费版服务可能在功能或者体验上有所限制，您可以通过开通付费版解除该等限制，具体信息以官网描述为准",
                    "您在使用本产品服务前，应充分阅读并理解本产品官网对相应服务的描述，尤其是对免费服务、各级收费服务在功能、服务标准上的限制。对由于您未能充分理解上述描述和限制而造成的任何损失，我们不承担任何法律责任。"
                ]
            },
            {
                title: "账户",
                content: [
                    "为使用本产品，您必须注册一个账户。注册账户时，您需要提供真实、准确的信息。如果您的信息发生变更，请及时在您的账户中对信息进行更新。您对(a)您的账户的保密性，以及用于启用您访问服务的任何密码、身份验证密钥或安全凭据的安全性负责，和(b)所有在您账户下的活动，不论是您还是您的最终用户的活动负责。如果您的账户下有任何未经授权或滥用行为或者任何与服务相关的安全事件，请您立即通知我们。您认可并同意我们不会对您账户中任何未经授权或滥用行为负责，除非这是由我们违反本协议所造成的。",
                    "灵动无线和您应遵守相关法律法规进行实名认证。就本产品的使用，灵动无线可能要求您提供进一步的身份资料、经营资质和信息，以完成身份认证或资格验证。仅在完成相应身份认证及资格验证后，您才可以订购及使用相关服务。您理解并同意灵动无线有权自行或委托第三方，审查您在实名认证时提供的信息是否真实、准确及有效，对于违反本协议约定的账户信息，灵动无线有权采取不予通过、屏蔽或删除等处理。您知晓并同意，如您未依照相关法律法规及灵动无线的要求完成实名认证，将影响您访问或使用本服务。",
                    "您声明并保证，您向灵动无线提供的信息均为真实、准确、有效、最新的，否则您应承担由此产生的一切法律责任。尽管有前述规定，灵动无线无义务对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核 实任何登记资料的真实性、准确性、完整性、适用性及/或是否为最新资料的责任。",
                    "灵动无线建议您妥善保管您的注册邮箱、手机号、密码和名称，准确输入该等信息将作为您访问登录本产品并享有服务的关键环节。如果您发现有人未经授权使用您的账户信息或怀疑任何人未经授权可能能够访问您的私有内容，您应立即更改密码，并向我们反馈。",
                ]
            },
            {
                title: "使用",
                content: [
                    "您声明并保证您上传或储存在本产品中的内容不违反本协议并且符合法律法规。您应对您上传或储存的内容的合法性、准确性、完整性和可靠性负责。 您应负责获得并持续保有任何与您的内容相关的通知、同意或授权。除非 法律另有明确规定，否则灵动无线不承担任何与您上传或储存的内容有关的义务和责任。若您在本产品上传、储存侵犯他人知识产权或其他违法、违规的内容，灵动无线有权利予以删除并保留移交司法机关处理的权利。",
                    "您不得使用本产品上传、储存、共享、发送或传播任何敏感信息和违反国家 法律法规的信息，包括但不限于下列信息:<br/>" +
                    "- 反对宪法所确定的基本原则的;\n<br/>" +
                    "- 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的; - 损害国家荣誉和利益的;\n<br/>" +
                    "- 煽动⺠族仇恨、⺠族歧视，破坏⺠族团结的;\n<br/>" +
                    "- 破坏国家宗教政策，宣扬邪教和封建迷信的;\n<br/>" +
                    "- 散布谣言，扰乱社会秩序，破坏社会稳定的;\n<br/>" +
                    "- 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;\n<br/>" +
                    "- 侮辱或者诽谤他人，侵害他人合法权益的;\n<br/>" +
                    "- 含有法律、行政法规禁止的其他内容的。\n<br/>" +
                    "  您承诺发表言论要:爱国、守法、自律、真实、文明。不传播任何非法的、\n<br/>" +
                    "骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽 的、危害国家安全的、泄露国家机密的、破坏国家宗教政策和⺠族团结的 以及其它违反法律法规及政策的内容。若您的行为不符合以上提到的服务协议。我们将作出独立判断立即暂停或终止您的服务账号。您需自行对其全部行为承担法律责任，我们不承担任何法律责任。",
                    "您不得发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商 业秘密等合法权利的内容。",
                    "您不得制作、复制、发布、传播涉及他人隐私、个人信息或资料的信息。",
                    "您不得发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的内容。",
                    "您应当对您使用本产品的一切行为及所有在您账户下的活动(不论是您还是您授权他人的活动)负责。您不得利用本产品从事违反法律法规、违反本用户协议约定、危害网络安全、危害计算机系统安全、破坏产品完整性或其他侵害任何第三人利益的活动。若您从事了上述行为，灵动无线有权暂停或终止您的账户，并拒绝您于现在和未来使用本产品，由此对灵动无线或第三人造成的损失或由此产生的一切法律责任均由您全部承担。"
                ]
            },
            {
                title: "内容和知识产权",
                content: [
                    "您在本产品提交的内容之所有权归您所有。您明白灵动无线对您提供的任何内容不在任何方面负责，灵动无线没有义务预先审查此类内容。但是，我们有权随时决定您提供的任何内容是否符合相关法律规定或本协议的相关约定，并可随时预先审查、转移、拒绝、修改和/或删除您上传的内容，而不需事先通知您。若您使用本服务的行为存在或涉嫌任何违反国家法律法规或侵犯任何第三方合法权益的情形，灵动无线有权直接删除该等违反规定的信息，并可以暂停或终止向您服务。",
                    "本产品的所有权及所有与本产品服务相关的知识产权(包括但不限于源代码、目标代码、文档资料、界面设计、版面框架、以及任何由灵动无线根据维护与技术支持提供的软件、资料等)归灵动无线所有。您认同灵动无线拥有的所有权及知识产权，并承诺尊重及不以任何方式侵害灵动无线对本产品享有的所有权及知识产权。未经灵动无线书面许可，您不能复制、拷⻉、 转让、许可或提供他人使用上述知识成果，或者私自使用任何部分代码和外观设计，否则您应承担相应的法律责任，且灵动无线有权终止服务且不退还任何费用。"
                ]
            },
            {
                title: "隐私政策",
                content: [
                    "您在使用本产品前，通过阅读和点击同意《隐私政策》并实际使用本服务，即表示您授权灵动无线合法收集和使用有关您及您所使用本服务的技术性或诊断性信息。基于提供服务所必需，手机端用户仅在用于反馈建议和问题时调用录音、拍照、读取相册等权限。收集到的这些信息将用于改进本产品服务的内容和技术，提升我们的服务品质。灵动无线不会将您的信息和内容分享或出售给第三方。但以下情况除外:<br/>" +
                    "- 基于特定的服务目的且事先获得您的明确授权;\n<br/>" +
                    "- 遵守适用的法律法规;\n<br/>" +
                    "- 遵守法院命令或其他法律程序的规定;\n<br/>" +
                    "- 遵守相关政府主管部⻔的要求;\n<br/>" +
                    "- 与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的情 形下;\n<br/>" +
                    "- 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信 息公开等渠道;\n<br/>" +
                    "- 灵动无线认为为遵守适用的法律法规、维护社会公共利益、或保护灵动无线的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需 的情形下;\n<br/>" +
                    "- 您违反了本服务协议，且灵动无线出于维权需要向第三方提供的情形 下;\n<br/>" +
                    "- 法律法规规定的其他情形。<br/>",
                    "保护用户个人信息是灵动无线的一项基本原则，灵动无线将按照《隐私政策》的约定收集、使用、储存和分享您的个人信息，以及您如何管理您的个人信息、我们如何采取必要措施保障您的个人信息安全、我们响应您的权利请求等。您声明并保证，您已仔细阅读、完全理解并同意上述 《隐私政策》的全部内容。若您不同意本协议及《隐私政策》， 请您立即停止使用我们提供的任何服务或产品。"
                ]
            },
            {
                title: "数据和信息安全",
                content: [
                    "我们与您共同负有维护账号安全的责任。我们在目前的技术水平下努力保护您的账号在服务器端的安全，并不断更新技术措施。但互联网并非绝对安全的环境，我们特别提醒您应该妥善保管您的账号和密码，杜绝私自转借乃至出售账号等有害于账号安全的行为。此外，灵动无线建议您采用复杂字符组合设定您的账号密码。请您理解，灵动无线不对因您自身有违相关法律法规规定和本协议约定使用账号的行为及其所导致的数据未经授权访问、泄露、破坏乃至销毁等造成的损失承担责任。",
                    "灵动无线将依照法律、行政法规的规定和国家标准的强制性要求，采取合理的技术措施和其他必要措施，努力保护您的数据和信息安全。但是，互联网数据传输、存储、转换均可能存在一定未知且不确定的数据安全⻛险，该等⻛险将导致包括但不限于数据丢失、泄露、损坏、无法读取或提取等后果。您确认，您已明确知晓并同意接受该等因互联网引发的⻛险和后果， 并已采取恰当的措施(例如数据备份等)，以便在该等⻛险发生时将损失 降至最低。",
                    "您知悉并认可，本产品服务是基于第三方云服务所提供的SAAS服务，鉴于网络服务的特殊性(包括但不限于云服务器的稳定性问题、通讯基础设施 故障、网络黑客攻击、政府管制等行为的存在及其他我们无法控制的情形)，我们提供的服务可能会出现中断、不能及时传送信息或其他不能满足您的要求的情况，请您知悉并理解，该情况将不视为我们违反本协议约定，但我们将尽可能及时通过网页公告、系统通知、短信或者其他合理的方式通知您。"
                ]
            },
            {
                title: "免责声明",
                description: "您知悉并同意，下列情况下，灵动无线无需向您承担任何责任:",
                content: [
                    "由于您维护不当或保密不当，导致数据、资料、口令、密码等丢失或泄漏，或其他非因灵动无线原因导致的个人信息的泄漏，灵动无线不承担任 何法律责任;",
                    "任何由于不可抗力、黑客攻击、电脑病毒侵入、网络运营商原因或政府管制等灵动无线无法合理控制的原因而造成本产品使用中止、中断、延误、使用限制、使用异常、使用不能、暂时性网站关闭等，灵动无线不承担任何法律责任;",
                    "您应对通过本产品上传或储存文件、输入数据的合法性以及获得文件、数 据、内容的方式的合法性负责，因上述文件、数据、内容引发的一切纠纷，由您承担全部法律责任，灵动无线不承担任何法律责任;",
                    "互联网是一个开放平台，如果您将图片、文字等内容上传并传播，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，您应充分意识 到此类⻛险的存在。您同意使用灵动无线服务所存在的此类⻛险及后果将完全由您自己承担，灵动无线不承担任何责任。",
                    "您理解并确认，受技术所限，灵动无线无法保证其所提供的服务毫无瑕疵，但我们承诺将不断提升服务质量及服务水平，为您提供更加优质的服务。据此，您同意:如果灵动无线所提供的服务虽然存在瑕疵，但该等瑕 疵是当时行业技术水平所无法避免的，其将不被视为违约，灵动无线无须因此向您承担任何责任。",
                    "我们通过中华人民共和国境内的设施提供服务，我们无法确保您的使用行为、发布的信息及内容在其他国家或地区是适当的、可行的，当您在其他 司法辖区使用本软件及相关服务时，您应自行确保其遵守当地的法律法规，我们对此不承担任何责任。",
                    "如我们发现、或通过第三方举报或投诉获知，您发布的内容存在或涉嫌违反国家法律法规或本软件规则的，我们有权依据合理判断不经通知立即采取一切必要措施(包括但不限于立刻删除您所发布的相关内容、冻结账户封号、向公安机关报案等)或配合国家网信部门、公检法等国家机关的执法要求对帐户做相应处理以减轻或消除您行为所造成的影响。"
                ]
            },
            {
                title: "服务变更/中断/终止",
                content: [
                    "您可随时注销您的账户并停止使用本产品服务。注销账户的方式可遵照官网的指引。您声明并保证，在您自主注销账户前已经将您上传、储存在本产品中的数据下载、备份完毕。您自主注销账户并经过缓冲期后，我们将不再负有保留您数据的任何法定或者约定义务。",
                    "您理解并同意，如因系统维护或升级的需要而暂停本产品服务、调整服务功能的，灵动无线将尽可能事先在网站上进行通告，以便于您提前做好商业安排，努力将对您带来的实际影响降到最低，但不因此承担任何法律责任。",
                    "当出现如下任一情形时，灵动无线可径行终止或暂停您使用所有或部分账 户和/或本服务<br/>" +
                    "- 您提供的资料不真实，或违反其他用户个人资料提供规则;\n<br/>" +
                    "- 您违反法律法规、本协议或您与灵动无线的其他约定;\n<br/>" +
                    "- 您要求取消或终止您的账户;\n<br/>" +
                    "- 未经灵动无线同意，将本产品产品用于商业目的或者其他任何营利性用 途;\n<br/>" +
                    "- 您对本产品的访问或使用可能会对本产品服务、灵动无线或第三方造成安全 ⻛险;\n<br/>" +
                    "- 需要听从法庭传票、法律命令或遵循法律程序;\n<br/>" +
                    "- 根据相关法律法规或政府机构的要求;\n<br/>" +
                    "- 因自然灾害、战争等不可抗力;\n<br/>" +
                    "- 本协议发生变更或修改，您不同意变更或修改后的用户协议。<br/>",
                    "您理解并认可，为技术升级、服务体系升级、或因经营策略调整或配合国 家重大技术、法规政策等变化，灵动无线不保证永久地提供某种服务，或可能变更所提供服务的形式、规格或其他方面，在终止该种服务或进行此种变更前，灵动无线将尽最大努力且提前以网站公告、站内信、邮件或短信等一种或多种方式进行事先通知;如终止提供该种服务的，灵动无线将尽合理的努力给您预留合理的时间，妥善处理后续事宜。",
                    "一旦您的账户被终止，您将无法正常使用本服务。此外，您可以选择在账户终止前删除您的账户下的所有信息和内容。"
                ]
            },
            {
                title: "本服务协议的完善和修改",
                content: [
                    "灵动无线有权根据互联网的发展和中华人⺠共和国有关法律、法规的变化， 不时地完善和修改本协议。灵动无线保留随时修改本协议的权利，并会将修改后的服务协议在官网上公布，您有义务及时查看官网上的消息更新，该等公布行为即可被合理地视为对您进行了有效通知送达。您在使用灵动无线的服务时，有必要对最新的《服务协议》进行仔细阅读和重新确认，经您确认和同意后，当发生相关争议时，以最新的服务协议为准。",
                    "如果您不同意灵动无线对本协议所做的修改，您应立即停止使用本产品服务。如果用户继续使用本产品服务，则视为用户接受我方对本协议所做的修改。"
                ]
            },
            {
                title: "⻘少年特别协议",
                content: [
                    "本产品服务主要面向成年人。若您是未成年人，请您确保您的监护人已仔细阅读、理解并接受本协议。并在征得您的监护人同意的前提下使用本产品服务或向灵动无线提供信息。",
                    "如您的监护人不同意您按照本协议使用本服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。",
                    "您声明并保证，您是具有完全⺠事行为能力的自然人。若您违背上述保证购买、使用本产品付费服务的，灵动无线不因此承担任何包括但不限于返还价款在内的任何法律责任，由此造成的损失应由您或您的监护人自行承担。"
                ]
            },
            {
                title: "法律适用及争议解决",
                content: [
                    "本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用 中华人⺠共和国大陆法律;如法律无相关规定的，参照商业惯例或者行业惯例",
                    "您因使用本产品服务所产生及与本协议有关的一切争议，由灵动无线与您协商解决。协商不成时，任何一方均可向灵动无线住所地人⺠法院提起诉讼。",
                    "若用户利用本服务从事任何违法或侵权行为，由用户自行承担全部责任，灵动无线不承担任何法律责任。因此给灵动无线或任何第三方造成任何损失的，用户应负责全额赔偿。"
                ]
            },
            {
                title: "联系我们",
                content: [
                    "当您有其他的投诉、建议或反馈时，请与我们联系。您可以将您的问题发送至 xiaoqiang@cutterman.cn，或通过官网提供的联系渠道与我们反馈。",
                    "北京灵动无线网络科技有限公司",
                    "邮箱： xiaoqiang@cutterman.cn",
                    "QQ：687356463",
                    "微博： cutterman"
                ]
            }
        ]

    },
    privacy: {
        title: "隐私政策",
        time: "更新时间 2022年02月07日",
        content: []
    }

}
